<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="400">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Ano Letivo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="content.ano"
                label="Ano Letivo"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="formattedDataInicio"
                label="Data de Início"
                outlined
                dense
                readonly
                append-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="formattedDataFim"
                label="Data de Término"
                outlined
                dense
                readonly
                append-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Habilidade } from '~/commons/classes/habilidade';

export default {
  props: new DialogProps(Habilidade),
  methods: {
    formatDateDiaMesAno(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
  },
  computed: {
    formattedDataInicio() {
      return this.content.dataInicio ? this.formatDateDiaMesAno(this.content.dataInicio) : '';
    },
    formattedDataFim() {
      return this.content.dataFim ? this.formatDateDiaMesAno(this.content.dataFim) : '';
    },
  }
};
</script>
